import React, { Component } from 'react';
//import {connect} from 'react-redux';

import './../../../scss/App.scss';

//import { trackingWrapper } from '../../utils/analytics';

class Final extends Component {

	constructor(props){
		super(props);

		this.key = 0;

		this.state = {

		}

	}

	componentDidMount(){
		//this.animateIn();

		//window.sounds.introBg.play();

		/*
		let _this = this;

		setTimeout(() => {
			_this.props.handleIntroComplete();
		}, 3000);
		*/

	}

	/*
	animateIn(){
		window.TweenMax.set(this.refs.logo, {transform:"translateX(-10%)", opacity:0});
		window.TweenMax.to(this.refs.logo, 2.2, {ease:"expo.out", transform:"translateX(-50%)", opacity:1});

		window.TweenMax.set(this.refs.tagline, {transform:"translateX(-90%)", opacity:0});
		window.TweenMax.to(this.refs.tagline, 2.2, {ease:"expo.out", transform:"translateX(-50%)", opacity:1});

		window.TweenMax.set(this.refs.crosswordBg, {opacity:0});
		window.TweenMax.to(this.refs.crosswordBg, 2, {ease:"linear", opacity:1});
		window.TweenMax.to(this.refs.crosswordBg, 20, {top:"-16vw"});

		let _this = this;
		setTimeout(() => {
			_this.aniamteOut();
			_this.props.handleIntroInComplete()
		}, 4000);
	}

	aniamteOut(){
		let _this = this;

		window.TweenMax.to(this.refs.crosswordBg, .2, {opacity:0});
		window.TweenMax.to(this.refs.host, .2, {opacity:0});
		window.TweenMax.to(this.refs.tuneIn, .3, {opacity:0});
		window.TweenMax.to(this.refs.bg, 1, {opacity:0, onComplete:function(){
			_this.props.handleIntroOutComplete();
		}});

		window.TweenMax.to(this.refs.logo, .4, {opacity:0});
		window.TweenMax.to(this.refs.logo, .5, {ease:"expo.in", transform:"translateX(-150%)"});

		window.TweenMax.to(this.refs.tagline, .4, {opacity:0});
		window.TweenMax.to(this.refs.tagline, .5, {ease:"expo.in", transform:"translateX(50%)"});
	}
	*/

	removeEmptyAnswers(){
		let filteredArray = [];

		for(let i = 0 ; i < this.props.answers.length ; i++){
			if(this.props.answers[i].value){
				filteredArray.push(this.props.answers[i]);
			}
		}

		return filteredArray;
	}

	renderAnswers(){
		return(
			<div className="answers">
				{this.removeEmptyAnswers().map(answer => {
					let wordFragment = answer.value.split(" ");

					//console.log("wordFragment split", wordFragment);

					for(let i = 0; i < wordFragment.length; i++){
						let blankedOutWord = wordFragment[i].charAt(0);

						for(let j = 1; j < wordFragment[i].length; j++){
							blankedOutWord += "_";
						}

						wordFragment[i] = blankedOutWord;
					}

					//

					let maskedAnswer = "";

					for(let i = 0; i < wordFragment.length; i++){

						if(i > 0){
							maskedAnswer += " ";
						}
						maskedAnswer += wordFragment[i];
					}


					return(
						<div className="answer" key={this.key++}>{maskedAnswer}</div>
					)
				})}
			</div>
		);
	}

	render() {

		return (
			<div id="final">
				<div className="question">{this.props.question}</div>
				{this.renderAnswers()}
			</div>
		);
	}
}

export default Final;


// WEBPACK FOOTER //
// ./src/js/components/generator/Final.js